import { cn } from '@/shared/lib/utils/classnames';
import type { ImageBlock as ImageBlockType } from '@/shared/types/blocks';

type ImageBlockProps = Omit<ImageBlockType, 'type' | 'id'>;

/**
 * ImageBlock - 이미지
 *
 * 단일 이미지를 표시합니다.
 */
export function ImageBlock({ src, alt, height, width, rounded = false }: ImageBlockProps) {
  const widthStyle = width === 'full' ? '100%' : width ? `${width}px` : 'auto';

  return (
    <img
      src={src}
      alt={alt || ''}
      className={cn('object-cover', rounded && 'rounded-lg')}
      style={{
        width: widthStyle,
        height: height ? `${height}px` : 'auto',
      }}
    />
  );
}
